(async () => {

  if (!customElements.get('product-card-swiper')) {

    const { default: Swiper, Navigation } = await import("swiper");

    Swiper.use([
      Navigation
    ]);

    class ProductCard extends HTMLElement {
      constructor() {
        super();

        let windowWidth = window.innerWidth;
        this.swiperElement = this.querySelector('[data-swiper-product-card]');

        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerView: 1,
          direction: 'horizontal'
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        window.addEventListener('load', () => {
          if (windowWidth < 768) {
            this.init();
            this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
          } else if(this.swiperInstance) {
            this.querySelectorAll('button').forEach(button => button.classList.add('hidden'));
          }
        });

        window.addEventListener('resize', () => {
          windowWidth = window.innerWidth;
          if (windowWidth < 768) {
            this.init();
            this.querySelectorAll('button').forEach(button => button.classList.remove('hidden'));
          } else if(this.swiperInstance) {
            this.querySelectorAll('button').forEach(button => button.classList.add('hidden'));
          }
        });
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
    }

    window.ProductCard = ProductCard;

    customElements.define('product-card-swiper', ProductCard);

  }

})();

class productColorsPopup extends HTMLElement {
  constructor() {
    super();

    this.popupCloseButton = this.closest('[data-product-card]').querySelector('[data-product-colors-popup-close]');
    this.popup = this.closest('[data-product-card]').querySelector('[data-product-colors-popup]');
    
    this.addEventListener('click', () => {
      this.popup.classList.add('product-card__colors-popup--is-open');
    });

    this.popupCloseButton.addEventListener('click', () => {
      this.popup.classList.remove('product-card__colors-popup--is-open');
    });
  }
}

if (!customElements.get('product-colors-popup')) {
  customElements.define('product-colors-popup', productColorsPopup);
}
